// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pf-0";
export var buttonContainer = "_pf-3";
export var cancelButton = "_pf-4";
export var headerSection = "_pf-6";
export var headerTitle = "_pf-9";
export var messageSideLeft = "_pf-1";
export var messageSideRight = "_pf-2";
export var orderNumberContainer = "_pf-7";
export var orderNumberLabel = "_pf-8";
export var submitButton = "_pf-5";